import { TICKER_ITEMS } from "../../content";

export const Ticker = ({ items = TICKER_ITEMS }) => {
  const row = (key) => (
    <div className="flex shrink-0 items-center" key={key}>
      {items.map((item, i) => (
        <span key={i} className="mono text-[13px] tracking-[0.3em] text-white flex items-center whitespace-nowrap">
          <span className="px-8">{item}</span>
          <span className="text-[#FE0000]">◆</span>
        </span>
      ))}
    </div>
  );
  return (
    <section className="border-y border-white/10 py-5 overflow-hidden" data-testid="ticker-section">
      <div className="flex marquee-track">{row("a")}{row("b")}{row("c")}</div>
    </section>
  );
};
